import React, { useState, Dispatch, SetStateAction } from "react";
import getModalStyle from "../../../../../util/getModalStyle";
import { setAppointment } from "../../../../../api/ServiceApi";
import { formatAppointmentDate } from "./AptChangeModal.biz";

function useAptSelector(
  serviceId: string,
  setSearch: Dispatch<SetStateAction<boolean>>,
  handleClose: () => void
) {
  const [modalStyle] = useState(() => getModalStyle(50, 50));

  const [date, setDate] = useState("");
  const [time, setTime] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [toggleEmail, setToggleEmail] = useState(false);

  const [err, setErr] = useState("");

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) =>
    setToggleEmail(e.target.checked);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    state: "date" | "time"
  ) => {
    state === "date" && setDate(event.target.value);
    state === "time" && setTime(event.target.value);
  };

  const handleSubmit = async () => {
    if (!date || !time) {
      setErr("Must Enter a Date and Time");
      return;
    } else {
      setIsLoading(true);
      const apptDate = formatAppointmentDate(date, time);

      try {
        const response = await setAppointment({
          serviceId,
          appointment: apptDate,
          sendEmail: toggleEmail,
        });

        if (response.data === "Success") {
          setIsLoading(false);
          setErr("");
          setSearch((prev) => !prev);
          handleClose();
        }

        if (response.data !== "Success") {
          setIsLoading(false);
          setErr(response.data);
        }
      } catch (err) {
        setIsLoading(false);
        setErr("A Problem Occurred");
      }
    }
  };

  const preventEnterEffects = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      return handleSubmit();
    }
  };

  return {
    handleKeyDown,
    preventEnterEffects,
    handleSubmit,
    handleChange,
    handleToggle,
    err,
    toggleEmail,
    isLoading,
    modalStyle,
    time,
    date,
  };
}

export default useAptSelector;
